// First letter of the first name + first letter of the last name (if provided), falling back to the
// username's first letter. Shared by the header avatar and the Users admin page.
export const getInitials = (user) => {
  if (user?.name) return `${user.name.charAt(0)}${user?.lastname ? user.lastname.charAt(0) : ""}`.toUpperCase();
  return user?.username?.charAt(0)?.toUpperCase() || "?";
};
